import { gql } from '@apollo/client';

import { lessonFragment } from '../fragments';

export default gql`
  mutation CreateLesson(
    $courseId: String!
    $groupId: String!
    $lessonId: String!
    $input: UpdateLessonInput
  ) {
    lesson(
      courseId: $courseId
      groupId: $groupId
      lessonId: $lessonId
      input: $input
    )
      @rest(
        type: "Lesson"
        path: "courses/{args.courseId}/groups/{args.groupId}/lessons/{args.lessonId}"
        method: "PUT"
      ) {
      ...Lesson
    }
  }
  ${lessonFragment}
`;
